
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../ui/TabBar.css';
import { faFilter, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

//{ data, setData, filterShow, setFilterShow, setAddShow, handlerMenuClick }
//Select с поиском
function TabBar({ tabData, tabSelected, tabClikHandler, filterShow, setFilterShow, setAddShow, showAdd, showFilter }) {

    /* 
        tabData-Данные для меню
        setData-Изменение данных меню
        filterShow - флаг состояния фильтра
        setFilterShow - изменит флаг состояния фильтра
        setAddShow - откроет модальное окно добавления
        handlerMenuClick - оброботчик клика по tab
        showAdd - Отображать кнопку добавления
        showFilter - Отображать фильтр?
        [
            { id_tab: 0, name: "Черновики", icon: faPen, showCount: true, count: 2 }
            , { id_tab: 1, name: "Исполнитель", icon: faCheck, showCount: false}
            , { id_tab: 2, name: "Наблюдатель", icon: faEye, showCount: false}
            , { id_tab: 3, name: "Будущие", icon: faRocket, showCount: false }
            , { id_tab: 4, name: "Все задачи", icon: faUsers, showCount: false }
            , { id_tab: 5, name: "Выполненные", icon: faFlagCheckered, showCount: false}
        ];
    */
    const stateSize = useSelector((state) => state.size);

    function change(id_tab) {
        tabClikHandler(id_tab)
    }

    return (
        <>
            {stateSize.desktop != true ? (
                <div className='m-tabbar-container'>
                    <div className="m-tabbar-block-btn-header">
                        <div className='m-tabbar-item first'></div>
                        {showAdd === true && (
                            <button className="m-tabbar-button-menu action" onClick={() => setAddShow(true)}>
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        )}
                        {showFilter === true && (
                            <button className={filterShow === true ? "m-tabbar-button-menu action active" : "m-tabbar-button-menu action"} onClick={() => setFilterShow(!filterShow)}>
                                <FontAwesomeIcon className="" icon={faFilter} />
                            </button>
                        )}
                        <div className='m-tabbar-item last'></div>
                    </div>
                    <div className="m-tabbar-block-btn">
                        <div className='m-tabbar-item first'></div>
                        {tabData.map(item => (
                            <div key={item.id_tab} className='m-tabbar-item'>
                                <button className={item.id_tab === tabSelected ? "m-tabbar-button-menu active" : "m-tabbar-button-menu"} onClick={() => change(item.id_tab)}>
                                    <FontAwesomeIcon icon={item.icon} className="mr-5" />{item.name}
                                    {item.count > 0 && <small>({item.count})</small>}
                                </button>
                            </div>
                        ))}
                        <div className='m-tabbar-item last'></div>
                    </div>
                </div>
            ) : (
                <div className="tabbar-container">
                    <div className='tabbar-block-btn'>
                        {showAdd === true && (
                            <button className="tabbar-button" onClick={() => setAddShow(true)}>
                                <FontAwesomeIcon className="" icon={faPlus} /> Добавить
                            </button>
                        )}
                    </div>
                    <div className='tabbar-block-menu'>
                        {tabData.map(item => (
                            <div key={item.id_tab} className='tabbar-item'>
                                <button className={item.id_tab === tabSelected ? "tabbar-button-menu active" : "tabbar-button-menu"} onClick={() => change(item.id_tab)}>
                                    <FontAwesomeIcon icon={item.icon} className="mr-5" />{item.name}
                                    {item.count > 0 && <small>({item.count})</small>}
                                </button>
                            </div>
                        ))}
                    </div>
                    {showFilter === true && (
                        <div>
                            <div className='tabbar-block-filter'>
                                <button className={filterShow === true ? "tabbar-button active" : "tabbar-button"} onClick={() => setFilterShow(!filterShow)}>
                                    <FontAwesomeIcon className="ml-5 mr-5" icon={faFilter} />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}
export default TabBar;